import { useEffect } from "react"
import DefaultLayout from "./DefaultLayout"

export default function App() {
  return <DefaultLayout />
}
